export default __webpack_public_path__ + "static/media/VolvoNovum-Medium.968d41b0.ttf";